import React from 'react';
import { useStoreState } from 'easy-peasy';

import AppSiteFooter from './appsitefooter';
import CLIFooter from './clifooter'

import '../../assets/layout/footer.css';
import { FLOW } from '../../models/websiteTypesConstants';

function Footer() {

    const mainSettings = useStoreState(state => state.siteSettingsModel.mainSettings);
    const brandSettings = useStoreState(state => state.siteSettingsModel.brandSettings);

    const footerStyle = {
        backgroundColor: brandSettings.FooterBgColor || "",
        color: mainSettings.Flow === FLOW.CLI ? "#666": "#fff"
    };
    

    return (
        <div className="footer-container" style={footerStyle}>
            {mainSettings.Flow === FLOW.CLI ? <CLIFooter/> :
                <AppSiteFooter />
            }
        </div>
    );
}

export default Footer;